<script>
export default {
    name: "Loader Point",
    
    props: {
        showLoader: {
            type: Boolean,
            default: true
        },

        color: {
            String,
        }
    },

    watch: {
        showLoader(newValue) {
            this.$emit('loader-toggle', newValue);
        }
    },
}
</script>


<template>
    <div v-if="showLoader" class="loaderPoints">
        <span :style="{ backgroundColor: color }"></span>
        <span :style="{ backgroundColor: color }"></span>
        <span :style="{ backgroundColor: color }"></span>
    </div>    
</template>

<style scoped>
.loaderPoints {
	outline: 1px solid transparent;
	font-size:0px;
	padding:0px;
	display:inline-block;
}
.loaderPoints span {
  background-color: var(--black);
	border-radius:100%;
	vertical-align:middle;
	display:inline-block;
  width: 3px;
  height: 3px;
	margin:2px 1px;
	-webkit-animation:loaderPoints 0.8s linear infinite alternate;
	animation:loaderPoints 0.8s linear infinite alternate;
}
  
.loaderPoints span {
    width: 10px;
    height: 10px;
    margin: -8px 2px 0px;
}

.loaderPoints.loader-white span {
  background-color: #fff;
}

.loaderPoints span:nth-child(1){
	-webkit-animation-delay:-0.8;
	animation-delay:-0.8s;
}
.loaderPoints span:nth-child(2) {
	-webkit-animation-delay:-0.53333s;
	animation-delay:-0.53333s;
}
.loaderPoints span:nth-child(3) {
	-webkit-animation-delay:-0.26666s;
	animation-delay:-0.26666s;
}
@keyframes loaderPoints{
    from {transform: scale(0, 0);}
    to {transform: scale(1, 1);}
}
@-webkit-keyframes loaderPoints{
    from {-webkit-transform: scale(0, 0);}
    to {-webkit-transform: scale(1, 1);}
}
</style>